import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import detector from 'i18next-browser-languagedetector';

import en from './en';
import es from './es';

i18n.use(detector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false // react already safes from xss
        },
        defaultNS: 'common',
        ns: ['common', 'routes'],
        resources: {
            en: {
                agreements: en.agreementTranslations,
                common: en.commonTranslations,
                components: en.componentTranslations,
                routes: en.routeTranslations,
                notifications: en.notificationTranslations,
                questions: en.questionTranslations,
                formSections: en.formSectionsTranslations,
                surveys: en.surveyTranslations
            },
            es: {
                agreements: es.agreementTranslations,
                common: es.commonTranslations,
                components: es.componentTranslations,
                routes: es.routeTranslations,
                notifications: es.notificationTranslations,
                questions: es.questionTranslations,
                formSections: es.formSectionsTranslations,
                surveys: es.surveyTranslations
            }
        }
    });

export default i18n;
